import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ___ } from '@ts/common/language';
import { DefaultPropValues } from '@ts/components/form/types';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorMessage',
    props: {
        error: {},
        small: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (__props.error && __props.error.trim() !== '')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["invalid-message", { 'text-xs': props.small === true }]),
                    role: "alert"
                }, _toDisplayString(__props.error), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
